import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AxiosError } from 'axios'

import { invoices } from 'src/axious/invoices'
import { Header } from 'src/components'
import { CustomButton, TransactionInput } from 'src/components/ui'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import styles from './Replenishment.module.scss'

const ReplenishmentPage = () => {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = React.useState<string>('')

  const navigate = useNavigate()

  const reducingBalanceStars = useGlobalStore((store) => store.reducingBalanceStars)

  const changeInputState = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setInputValue(value)

    e.target.style.width = `${Math.max(value.length, 1)}ch`
  }

  const replenishmentOfStars = async () => {
    try {
      const res = await invoices('post', { amount: +inputValue })

      window.Telegram.WebApp.openInvoice(res.invoice_link, (status) => {
        if (status === 'paid') {
          reducingBalanceStars(-Number(inputValue))
          navigate('/replenishment/success?type=replenish')
        } else if (status === 'failed') {
          navigate('/replenishment/error')
        }
      })
    } catch (err) {
      navigate('/replenishment/error')
      if (err instanceof AxiosError) {
        if (err.response) {
          console.log('Server error:', err.response.status, err.response.data)
        } else if (err.request) {
          console.log('Network error:', err.request)
        } else {
          console.log('Unexpected error:', err.message)
        }
      } else {
        console.log('Non-Axios error', err)
      }
    }
  }

  return (
    <>
      <Header variant='back' color='white' path='/' />

      <main className={styles.wrapper}>
        <h1 className={styles.wrapper_title}>{t('replenishment.title')}</h1>
        <p className={styles.wrapper_subtitle}>{t('replenishment.subtitle')}</p>

        <div className={styles.wrapper_main}>
          <TransactionInput commission={'00.00'} inputValue={inputValue} handleChange={changeInputState} />
        </div>

        <CustomButton
          className={styles.wrapper_btn}
          variant={inputValue.length === 0 ? 'not-active' : 'contained'}
          color='white'
          onClick={replenishmentOfStars}
        >
          {t('main_page.replenish')}
        </CustomButton>
      </main>
    </>
  )
}

export default ReplenishmentPage
